import { actions as segmentioActions } from '@saucelabs/sl-util-segmentio';

const PerformanceTab = 'Performance Tab';

export const PERFORMANCE_EVENTS = {
  OPEN_FILMSTRIP_METRICS: `${PerformanceTab} Open FilmStrip Metrics`,
  HISTORY_OPEN: `${PerformanceTab} Open History`,
  PERFORMANCE_REPORT_OPEN: `${PerformanceTab} Open Performance Report`,
  CHANGE_URL: `${PerformanceTab} Change URL`,
};

export const trackEvent = (event) => segmentioActions.recordTrack(event);

export default trackEvent;
